import {TextError, Spacing01} from '@RHEnvironmental/pattern-library-tokens';
import {px} from './px';

export const formErrorMessageStyles = {
  color: TextError,
  textStyle: 'textBodyMedium4',
  marginTop: px(Spacing01),
};